module.exports = __webpack_public_path__ + "img/7VE.4a06efb5.gif";